__turbopack_context__.v({
  "empty_review_text": "index-module-scss-module__-USf2a__empty_review_text",
  "protection-link": "index-module-scss-module__-USf2a__protection-link",
  "review": "index-module-scss-module__-USf2a__review",
  "title": "index-module-scss-module__-USf2a__title",
});
